export default __webpack_public_path__ + "static/media/Curso-Excel-Inter.601ae354.png";